import { render, staticRenderFns } from "./Subitems.vue?vue&type=template&id=213b5858&"
import script from "./Subitems.vue?vue&type=script&lang=js&"
export * from "./Subitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports